import "./reset.scss";
import "./App.scss";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import Destinations from "./pages/Destinations";
import DestinationDetails from "./pages/DestinationDetails";
import Watch from "./pages/Watch";
import Guides from "./pages/RoadNotes";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ScrollTop from "./components/scrollTop/ScrollTop";
import AdminRoadNotes from "./components/forms/AdminRoadNotes";
import QrStats from "./components/admin/QrStats";
import AdminLayout from "./components/layout/AdminLayout";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import VerifyEmail from "./pages/auth/VerifyEmail";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import FuelUp from "./pages/FuelUp";
import FuelUpSuccess from "./pages/FuelUpSuccess";
import Donations from "./components/admin/Donations";
import PersistLogin from "./pages/auth/PersistLogin";
import AdminRoute from "./components/admin/AdminRoute";
import AdminMessagesInbox from "./components/admin/AdminMessagesInbox";
import AdminBlogCreate from "./components/admin/AdminBlogCreate";
import BlogFeed from "./pages/BlogFeed";
import BlogPostDetail from "./pages/BlogPostDetail";
import AdminBlogDashboard from "./components/admin/AdminBlogDashboard";
import AdminBlogEdit from "./components/admin/AdminBlogEdit";
import AdminOverview from "./components/admin/AdminOverview";
import AdminSettings from "./components/admin/AdminSettings";
import AdminProfile from "./components/admin/AdminProfile";
import AdminGallery from "./components/admin/AdminGallery";
import Gallery from "./pages/Gallery";
import AdminMilestones from "./components/admin/AdminMilestones";
import AdminProduct from "./components/admin/AdminProduct";
import StoreCatalog from "./pages/storeCatalog/StoreCatalog";
import ProductDetailView from "./pages/storeCatalog/ProductDetailView";
import CheckoutPage from "./pages/shop/CheckoutPage";
import AdminOrdersManager from "./components/admin/AdminOrdersManager";
import UserDashboard from "./pages/user/UserDashboard";
import LegalDocument from "./pages/legal/LegalDocument";
import AdminLegalManager from "./components/admin/AdminLegalManager";
import AdminStockManager from "./components/admin/AdminStockManager";
import RoadNoteDetail from "./pages/RoadNoteDetail";
import AdminItinerary from "./components/admin/AdminItinerary";
import CookieConsentModal from "./components/cookieConsent/CookieConsentModal";
import AdminDestinations from "./components/admin/AdminDestinations";
import ScoutingMapList from "./pages/ScoutingMapList";
import AdminExpenses from "./components/admin/AdminExpenses";
import AdminCoupons from "./components/admin/AdminCoupons";
import CheckoutConfirmation from "./pages/shop/CheckoutConfirmation";
import CheckoutRecovery from "./pages/shop/CheckoutRecovery";

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Layout>
        <Routes>
          <Route element={<PersistLogin />}>
            {/* PUBLIC ROUTES */}
            <Route path="/" element={<Home />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/journeys" element={<Destinations />} />
            <Route path="/watch" element={<Watch />} />
            <Route path="/roadnotes" element={<Guides />} />
            <Route path="/roadnote/:slug" element={<RoadNoteDetail />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/shop" element={<StoreCatalog />} />
            <Route path="/shop/product/:id" element={<ProductDetailView />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/journeys/:slug" element={<DestinationDetails />} />
            <Route path="/blog" element={<BlogFeed />} />
            <Route path="/blog/:slug" element={<BlogPostDetail />} />
            <Route path="/fuel-up" element={<FuelUp />} />
            <Route path="/fuel-up/success" element={<FuelUpSuccess />} />
            <Route path="/legal/:slug" element={<LegalDocument />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route
              path="/checkout/confirmation"
              element={<CheckoutConfirmation />}
            />
            <Route path="/checkout/recover" element={<CheckoutRecovery />} />
            <Route path="/dashboard" element={<UserDashboard />} />
            <Route path="/community-map" element={<ScoutingMapList />} />

            {/* ADMIN ONLY */}
            <Route element={<AdminRoute />}>
              <Route path="/admin" element={<AdminLayout />}>
                <Route path="dashboard" element={<AdminOverview />} />
                <Route path="milestones" element={<AdminMilestones />} />
                <Route path="coupons" element={<AdminCoupons />} />
                <Route path="/admin/expenses" element={<AdminExpenses />} />
                <Route path="itinerary" element={<AdminItinerary />} />
                <Route path="destinations" element={<AdminDestinations />} />
                <Route path="legal" element={<AdminLegalManager />} />
                <Route path="profile" element={<AdminProfile />} />
                <Route path="orders" element={<AdminOrdersManager />} />
                <Route path="products" element={<AdminProduct />} />
                <Route path="gallery" element={<AdminGallery />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="road-notes" element={<AdminRoadNotes />} />
                <Route path="stock-manager" element={<AdminStockManager />} />
                <Route path="qr-stats" element={<QrStats />} />
                <Route path="donation" element={<Donations />} />
                <Route path="messages" element={<AdminMessagesInbox />} />
                <Route path="blogs" element={<AdminBlogDashboard />} />
                <Route path="blog/create" element={<AdminBlogCreate />} />
                <Route path="blog/edit/:id" element={<AdminBlogEdit />} />
                {/* <Route path="videos" element={<VideosAdmin />} /> */}
                {/* <Route path="settings" element={<AdminSettings />} /> */}
              </Route>
            </Route>
          </Route>
        </Routes>
      </Layout>
      <CookieConsentModal />
    </BrowserRouter>
  );
}

export default App;
